export const markupRender = (markup) => {
  return Object.entries(markup.list).length > 0 ?
    `${Object.entries(markup.list).map(([price, percent]) => {
      return `до ${price} р: ${percent} %`
    }).join(", ")}, выше - ${markup['~']} %`
    :
    `фикс ${markup['~']} %`;
}